export function formatViews(views: number): string {
  if (views >= 10000) return `${(views / 10000).toFixed(1)}万`;
  if (views >= 1000) return `${(views / 1000).toFixed(1)}千`;
  return `${views}`;
}

export function formatDate(iso: string): string {
  return iso.replace(/-/g, '.');
}